import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import classNames from "classnames";

export const LoanIcon = ({
  size,
  type,
  className = "",
  onClick,
  refHandler,
  id,
  dataId,
}: ISVGIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={classNames("svg-icon", {
        [`svg-icon__size-${size}`]: size,
        [`svg-icon__type-${type}`]: type,
        [className]: className,
      })}
      onClick={onClick}
      ref={refHandler}
      id={id}
      data-id={dataId ? `${dataId}-svg-icon` : ""}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14.6278 12.7953C14.8638 12.556 14.8628 12.1691 14.6255 11.9312C14.3882 11.6932 14.0045 11.6942 13.7685 11.9335L9.23054 16.5335C8.99451 16.7727 8.99555 17.1596 9.23285 17.3976C9.47015 17.6356 9.85385 17.6345 10.0899 17.3953L14.6278 12.7953Z"
        fill="#555555"
      />
      <path
        d="M13.858 15.3586C13.2558 15.3586 12.7676 15.8508 12.7676 16.4579C12.7676 17.0651 13.2558 17.5572 13.858 17.5572C14.4602 17.5572 14.9483 17.0651 14.9483 16.4579C14.9483 15.8508 14.4602 15.3586 13.858 15.3586Z"
        fill="#555555"
      />
      <path
        d="M9.05866 12.8759C9.05866 12.2682 9.54725 11.7756 10.15 11.7756C10.7527 11.7756 11.2412 12.2683 11.2412 12.8759C11.2412 13.4836 10.7527 13.9762 10.15 13.9762C9.54726 13.9762 9.05866 13.4836 9.05866 12.8759Z"
        fill="#555555"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4208 5.09833C15.6583 4.02084 14.5494 3.14789 13.5702 3.64151L13.0676 3.89487C12.3357 4.26383 11.4971 4.35665 10.7032 4.15656C9.49773 3.8527 8.41792 4.9783 8.75929 6.18295L8.83975 6.46689H7.93101C6.98333 6.46689 6.21509 7.24146 6.21509 8.19694C6.21509 9.07183 6.85919 9.79504 7.69537 9.91082L5.5891 13.6667C3.83472 16.795 6.22238 20.5 9.80027 20.5H14.1997C17.7776 20.5 20.1653 16.795 18.4109 13.6667L16.3047 9.91098C17.1414 9.7957 17.7861 9.07223 17.7861 8.19694C17.7861 7.24146 17.0179 6.46689 16.0702 6.46689H15.1192L15.4208 5.09833ZM6.64416 14.2681L9.07867 9.927H14.9213L17.3558 14.2682C18.6032 16.4924 16.9533 19.278 14.1997 19.278H9.80027C7.04673 19.278 5.3968 16.4924 6.64416 14.2681ZM13.8776 6.46689L14.2376 4.83324C14.2431 4.80829 14.2399 4.79346 14.236 4.78338C14.2312 4.77078 14.2215 4.75626 14.2058 4.74396C14.1902 4.73166 14.1739 4.72563 14.1606 4.72399C14.15 4.72269 14.1349 4.7231 14.1122 4.73453L13.6097 4.98789C12.619 5.48731 11.4838 5.61295 10.4093 5.3421C10.1088 5.26636 9.8396 5.54694 9.9247 5.84723L10.1003 6.46689H13.8776ZM7.42713 8.19694C7.42713 7.91637 7.65272 7.68891 7.93101 7.68891H16.0702C16.3485 7.68891 16.5741 7.91637 16.5741 8.19694C16.5741 8.47752 16.3485 8.70497 16.0702 8.70497H7.93101C7.65272 8.70497 7.42713 8.47752 7.42713 8.19694Z"
        fill="#555555"
      />
    </svg>

  );
};
